import logo from './logo.svg';
import './App.css';
import Sidebar from "./Sidebar/Sidebar";
import ProfileInfo from "./ProfileInfo/ProfileInfo";
import Education from "./Education/Education";
import Experience from "./Experience/Experience";
import Skills from "./Skills/Skills";
import Projects from "./Projects/Projects";
import GetInTouch from "./GetInTouch/GetInTouch";
import Footer from "./Footer/Footer";

function App () {
	return (
		<>
			<div className="MainApp">
				<Sidebar/>
				<div className="SubApp">
					<section id="Info"><ProfileInfo /></section>
					<section id="Education"><Education /></section>
					<section id="Experience"><Experience /></section>
					<section id="Skills"><Skills /></section>
					<section id="Projects"><Projects /></section>
					<section id="GetInTouch"><GetInTouch /></section>
					<section id="Footer"><Footer /></section>
				</div>
			</div>
		</>
	);
}

export default App;
